import axios from "./Axios";
import {UCP_URL} from "../config";

class Shipment {
    static async getOrdersShippingDetails({ orderId, appId, tenantId}) { 
        const {data, errors} = await axios()({
            url: UCP_URL + '/get-orders-shipping-details/' + '?orderId=' + orderId + '&tenantId=' + tenantId + '&appId=' + appId,
            method: 'GET',
        });
        if (errors && errors.length) {
            throw errors[0]
        }
        return data.response;
    }
}

export default Shipment
